import {
  DateRangePickerModal,
  useDateRangePickerModal,
} from '@ui/components/DateRangePicker';
import { LazyComponent } from '@ui/components/LazyComponent';
import { SEOTemplate } from '@ui/components/SEO';
import type { NextPage } from 'next';

import StatsContent from './StatsContent';

export const StatsVno: NextPage = () => {
  const isDateRangePickerModalOpen = useDateRangePickerModal((s) => s.isOpen);

  return (
    <>
      <SEOTemplate
        title={`Track Veno Finance VNO Stats - Emissions, Usage, Locking & Unlocking Data`}
        description={`Monitor real-time and historical Veno Finance VNO emissions, usage, locking, unlocking, NFT staking, and unlock schedule data through our VNO liquid staking statistics charts.`}
      />
      <StatsContent defaultPage="vno" />
      <LazyComponent isOpen={isDateRangePickerModalOpen}>
        <DateRangePickerModal />
      </LazyComponent>
    </>
  );
};

export const StatsStaking: NextPage = () => {
  const isDateRangePickerModalOpen = useDateRangePickerModal((s) => s.isOpen);

  return (
    <>
      <SEOTemplate
        title={`Veno Finance Staking Analytics - CRO, ATOM & Token Liquid Staking Data`}
        description={`Access real-time and historical liquid staking analytics for CRO, ATOM, and other tokens on Veno Finance including amounts, fees, volumes, and more.`}
      />
      <StatsContent defaultPage="staking" />
      <LazyComponent isOpen={isDateRangePickerModalOpen}>
        <DateRangePickerModal />
      </LazyComponent>
    </>
  );
};
